<template>

    <div class="login">
        <div>
            <ResetNewPasswordComponent />
        </div>
    </div>

</template>

<script>
import ResetNewPasswordComponent from '@/components/users/ResetNewPasswordComponent.vue';
export default {
    components: {
        ResetNewPasswordComponent,
    },
    data() {
        return {
            // loading: true,
        }
    },
    method: {

    },
    created() {
        // this.loading = false
    }
}
</script>
<style scoped></style>